var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-drawer',{attrs:{"width":"35%","label-col":4,"wrapper-col":14,"visible":_vm.open},on:{"close":_vm.onClose}},[_c('a-divider',{attrs:{"orientation":"left"}},[_c('b',[_vm._v("消息内容 ")])]),_c('div',{domProps:{"innerHTML":_vm._s(_vm.form.newsContent)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }